import { render, staticRenderFns } from "./ComprasGraph.vue?vue&type=template&id=5e9c8838"
import script from "./ComprasGraph.vue?vue&type=script&lang=js"
export * from "./ComprasGraph.vue?vue&type=script&lang=js"
import style0 from "./ComprasGraph.vue?vue&type=style&index=0&id=5e9c8838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports